import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from './auth';
import { checkTokenValidity } from './token';

const useAuth = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const checkToken = async () => {
            if (!getToken()) {
                navigate("/auth/sign-in");
            } else {
                const isValid = await checkTokenValidity();
                if (!isValid) {
                    navigate("/auth/sign-in");
                }
            }
        };

        checkToken();
    }, [navigate]);
};

export default useAuth;
